<div class="list-card-view-container">
	@for (item of displayedListItems; track $index) {
	<mat-card
		class="list-card mat-elevation-z8 m-2 mb-1 mt-0"
		[ngClass]="{
			'related-clip-content': (dataAdministrationType === 'CLIPPING' && !utils.getParameterByName(item, 'main')) || utils.getParameterByName(item, 'autoTaggedMultipleCriteria'),
			'auto-grouped-content': dataAdministrationType === 'CLIPPING' && utils.getParameterByName(item, 'autoGrouped'),
			'auto-tagged-single-content': utils.getParameterByName(item, 'autoTaggedSingleCriteria'),
			'ai-auto-tagged-content': utils.getParameterByName(item, 'aiAutoTagged')
		}"
		[class]="getColorBadgeClass(item)"
		[id]="'tag-dropzone-list-' + getDisplayFieldByDataType('id', item)"
		cdkDropList
		(cdkDropListDropped)="tagsDropAssign.drop($event)">
		<mat-card-header class="p-0">
			<mat-card-title class="ms-3 me-2">
				<div class="d-flex">
					<div class="d-flex align-items-center flex-fill">
						<span class="me-2">{{ getDisplayFieldByDataType('initialDate', item) }}</span>

						<div class="buttons-bar">
							@if(dataAdministrationType === 'CLIPPING' && utils.getParameterByName(item, 'relatedCount')) {
							<button
								class="me-2 related-news-button"
								mat-raised-button
								color="primary"
								matTooltip="{{ 'CLIPS.RELATED_CONTENT' | translate }}"
								matTooltipPosition="below"
								aria-label="Related clips button"
								(click)="getRelatedClips(utils.suppressType(item))">
								<div class="d-flex align-items-center">
									<mat-icon class="mt-2">dataset_linked</mat-icon>

									@if(apiLoading && item.id === apiLoading.id) {
									<mat-spinner class="ms-1 me-2" diameter="15"></mat-spinner>
									} @else {
									<span>+{{ utils.getParameterByName(item, 'relatedCount') }}</span>
									}
								</div>
							</button>
							}
						</div>

						<div class="tags-placeholder d-flex gap-2 flex-row flex-wrap flex-fill ps-1">
							@for (tag of item.tags; track $index) {
							<div class="d-flex align-items-center">
								<div [style.background-color]="utils.getParameterByName(tag, 'colorCode')" class="tag-item d-flex align-items-center list-item mat-elevation-z2">
									<span (click)="removeTag(utils.suppressType(item), tag)">
										{{ utils.getParameterByName(tag, 'value') }}
									</span>
								</div>

								<!-- @if (tag.hasSentiment) {
								<div class="sentiment-button">
									<mat-icon [style.background-color]="utils.getParameterByName(tag, 'colorCode')" (click)="changeSentimentRating(item, tag)">{{
										getSentimentRating(item, tag)
									}}</mat-icon>
								</div>
								} -->
							</div>
							}
						</div>

						@if (autotagUiEnabled && dataAdministrationType === 'CONTRACT_NOTICES' && getTagSuggestionsForItem(item).length) {
						<div class="tag-suggestions-placeholder d-flex gap-2 flex-row flex-wrap flex-fill ps-1 mt-1">
							@for (suggestion of getTagSuggestionsForItem(item); track suggestion.tagId) {
							<div class="d-flex align-items-center tag-suggestion-item list-item mat-elevation-z1" [ngClass]="'tag-suggestion-color-' + (suggestion.color || 0)">
								<span>{{ suggestion.tagName }}</span>
								<mat-icon class="tag-suggestion-info" matTooltip="{{ getTagSuggestionTooltip(suggestion) }}" matTooltipPosition="above">info</mat-icon>
								<button
									mat-icon-button
									class="tag-suggestion-add"
									aria-label="Add suggested tag"
									matTooltip="{{ 'CLIPS.ADD_TAGS' | translate }}"
									matTooltipPosition="above"
									(click)="addSuggestedTag(item, suggestion)">
									<mat-icon>add</mat-icon>
								</button>
							</div>
							}
						</div>
						}
					</div>

					@if(getDisplayFieldByDataType('medium', item)) {
					<div class="medium-placeholder mat-elevation-z2 ms-auto px-2 mt-0 me-1 align-items-center cursor-pointer">
						<span (click)="openMediumLink(item)">{{ getDisplayFieldByDataType('medium', item) }}</span>
						@if (airingTimesLabel(item); as airingLabel) {
						<span class="airing-times"> · {{ airingLabel }}</span>
						}
					</div>
					}

					<div class="d-flex align-items-center buttons-bar">
						@if(dataAdministrationType === 'CLIPPING') {
						<button
							mat-raised-button
							color="primary"
							class="edit-button"
							matTooltip="{{ 'CLIPS.OPEN_LINKS' | translate }}"
							matTooltipPosition="below"
							aria-label="Open all links button"
							(click)="itemAction('OPEN_ALL_LINKS', item)">
							<mat-icon class="ms-1">open_in_new</mat-icon>
						</button>

						<button mat-raised-button color="primary" class="mx-1" [matMenuTriggerFor]="menu"><mat-icon>picture_as_pdf</mat-icon></button>
						<mat-menu #menu="matMenu">
							<button mat-menu-item (click)="itemAction('OPEN_REPORT', item, 'GROUP')">{{ 'CLIPS.GROUP_REPORT' | translate }}</button>
							<button mat-menu-item (click)="itemAction('OPEN_REPORT', item, 'SINGLE')">{{ 'CLIPS.REPORT' | translate }}</button>
						</mat-menu>
						} @else if(dataAdministrationType === 'SALES' || dataAdministrationType === 'BANKRUPTCIES') {
						<button
							mat-raised-button
							color="primary"
							class="mx-1"
							matTooltip="{{ 'CLIPS.REPORT' | translate }}"
							matTooltipPosition="below"
							aria-label="Open report button"
							(click)="itemAction('OPEN_REPORT', item, 'SINGLE')">
							<mat-icon class="ms-1">notes</mat-icon>
						</button>
						} @else {
						<!-- <button
							mat-raised-button
							color="primary"
							class="mx-1"
							matTooltip="{{ 'CLIPS.REPORT' | translate }}"
							matTooltipPosition="below"
							aria-label="Open report button"
							(click)="itemAction('OPEN_REPORT', item, 'SINGLE')">
							<mat-icon class="ms-1">picture_as_pdf</mat-icon>
						</button> -->
						}

						@if (dataAdministrationType === 'TRANSCRIPTIONS') {
						<button
							mat-raised-button
							color="primary"
							class="me-1"
							matTooltip="{{ 'BUTTON.EXPORT' | translate }}"
							matTooltipPosition="below"
							aria-label="Export button"
							(click)="itemAction('EXPORT_TRANSCRIPTION', item)">
							<mat-icon class="m-0">download</mat-icon>
						</button>
						}

						@if (autotagUiEnabled && dataAdministrationType === 'CONTRACT_NOTICES' && utils.getParameterByName(item, 'noticeType')) {
						@if (utils.getParameterByName(item, 'reviewed')) {
						<span class="cluster-icon reviewed-icon" color="primary" matTooltip="{{ 'CONTRACT_NOTICES.REVIEW_BUTTON' | translate }}" matTooltipPosition="below">
							<mat-icon>task_alt</mat-icon>
						</span>
						} @else {
						<button
							mat-raised-button
							color="primary"
							class="me-1"
							matTooltip="{{ 'CONTRACT_NOTICES.REVIEW_BUTTON' | translate }}"
							matTooltipPosition="below"
							aria-label="Mark reviewed"
							(click)="markReviewed(item)">
							<mat-icon class="m-0">task_alt</mat-icon>
						</button>
						}
						}

						<button
							mat-raised-button
							color="primary"
							class="edit-button"
							matTooltip="{{ 'BUTTON.EDIT' | translate }}"
							matTooltipPosition="below"
							aria-label="Edit button"
							(click)="itemAction('EDIT_LIST_ITEM', item)">
							<mat-icon class="ms-1">edit</mat-icon>
						</button>
					</div>
				</div>
			</mat-card-title>
		</mat-card-header>
		<mat-card-content class="px-3 py-1" [style.min-height]="getDisplayFieldByDataType('height')">
			<div class="d-flex justify-content-between">
				<div class="d-flex justify-content-start align-items-center">
					<mat-checkbox color="primary" [checked]="item.checked" (change)="selectAll($event.checked, item)">
						<span class="title" [ngClass]="checkItemHighlight(item)">{{ getDisplayFieldByDataType('title', item) }}</span>
					</mat-checkbox>
				</div>

				<div class="d-flex">
					<!-- Sentiment / Reach / Influence panel (admin, only when filtering by client) -->
					@if (utils.getParameterByName(item, 'clientId')) {
					<div class="admin-sentiment-panel d-flex align-items-center mt-1">
						<div class="metric-cell">
							<label class="metric-label">{{ 'CLIPS.REACH' | translate }}</label>
							@if (isEditingMetric(utils.suppressType(item), 'visibility')) {
							<input
								type="number"
								class="metric-input"
								min="0"
								max="100"
								[attr.data-edit-key]="utils.getParameterByName(item, 'id') + ':visibility'"
								[value]="utils.getParameterByName(item, 'visibilityIndex') ?? ''"
								(blur)="updateVisibilityIndex(utils.suppressType(item), $any($event.target).value); exitEditMetric(utils.suppressType(item), 'visibility')"
								(keydown.enter)="$any($event.target).blur()"
								(keydown.escape)="exitEditMetric(utils.suppressType(item), 'visibility')" />
							} @else {
							<span
								class="metric-display"
								(click)="enterEditMetric(utils.suppressType(item), 'visibility')"
								matTooltip="{{ 'CLIPS.REACH' | translate }}"
								matTooltipPosition="below">
								{{ utils.getParameterByName(item, 'visibilityIndex') ?? '/' }}
							</span>
							}
						</div>
						<div class="metric-cell">
							<label class="metric-label">{{ 'CLIPS.INFLUENCE' | translate }}</label>
							@if (isEditingMetric(utils.suppressType(item), 'sentiment')) {
							<input
								type="number"
								class="metric-input"
								min="-100"
								max="100"
								[attr.data-edit-key]="utils.getParameterByName(item, 'id') + ':sentiment'"
								[value]="utils.getParameterByName(item, 'sentiment')?.sentimentScore ?? ''"
								(blur)="setSentimentScore(utils.suppressType(item), $any($event.target).value); exitEditMetric(utils.suppressType(item), 'sentiment')"
								(keydown.enter)="$any($event.target).blur()"
								(keydown.escape)="exitEditMetric(utils.suppressType(item), 'sentiment')" />
							} @else {
							<span
								class="metric-display"
								(click)="enterEditMetric(utils.suppressType(item), 'sentiment')"
								matTooltip="{{ 'CLIPS.INFLUENCE' | translate }}"
								matTooltipPosition="below">
								{{ utils.getParameterByName(item, 'sentiment')?.sentimentScore ?? '/' }}
							</span>
							}
						</div>
						<div class="sentiment-group d-flex align-items-center ms-1">
							<button
								class="sentiment-btn"
								[ngClass]="getSentimentRating('POSITIVE', utils.suppressType(item), 'CLASS')"
								matTooltip="{{ 'CLIPS.SENTIMENT_RATING_TYPE.POSITIVE' | translate }}"
								matTooltipPosition="below"
								aria-label="Sentiment rating"
								(click)="createUpdateSentimentRating('POSITIVE', utils.suppressType(item))">
								<mat-icon>thumb_up_off_alt</mat-icon>
							</button>
							<button
								class="sentiment-btn"
								[ngClass]="getSentimentRating('NEUTRAL', utils.suppressType(item), 'CLASS')"
								matTooltip="{{ 'CLIPS.SENTIMENT_RATING_TYPE.NEUTRAL' | translate }}"
								matTooltipPosition="below"
								aria-label="Sentiment rating"
								(click)="createUpdateSentimentRating('NEUTRAL', utils.suppressType(item))">
								<mat-icon>remove</mat-icon>
							</button>
							<button
								class="sentiment-btn"
								[ngClass]="getSentimentRating('NEGATIVE', utils.suppressType(item), 'CLASS')"
								matTooltip="{{ 'CLIPS.SENTIMENT_RATING_TYPE.NEGATIVE' | translate }}"
								matTooltipPosition="below"
								aria-label="Sentiment rating"
								(click)="createUpdateSentimentRating('NEGATIVE', utils.suppressType(item))">
								<mat-icon>thumb_down_off_alt</mat-icon>
							</button>
						</div>
						@if (utils.getParameterByName(item, 'sentiment')?.id) {
						<div
							class="taxonomy-trigger d-flex align-items-center ms-1"
							(click)="openTaxonomyDialog(utils.suppressType(item))"
							matTooltip="{{ 'CLIPS.TAXONOMY.EDIT_TITLE' | translate }}"
							matTooltipPosition="below">
							@if (hasTaxonomyValues(utils.suppressType(item))) {
							@if (utils.getParameterByName(item, 'sentiment')?.sourceType) {
							<span class="taxonomy-chip source">{{ translateSourceTypeLabel(utils.getParameterByName(item, 'sentiment')?.sourceType) }}</span>
							} @for (topic of utils.getParameterByName(item, 'sentiment')?.industryTopics; track topic) {
							<span class="taxonomy-chip industry">{{ translateTopicLabel(topic) }}</span>
							} @for (topic of utils.getParameterByName(item, 'sentiment')?.corporateTopics; track topic) {
							<span class="taxonomy-chip corporate">{{ translateTopicLabel(topic) }}</span>
							} } @else {
							<span class="taxonomy-chip placeholder">—</span>
							}
						</div>
						}
					</div>
					} @if (utils.getParameterByName(item, 'important')) {
					<span class="cluster-icon important-icon" color="warn" matTooltip="{{ 'CLIPS.IMPORTANT_INFO' | translate }}" matTooltipPosition="below">!</span>
					} @if (utils.getParameterByName(item, 'screenshotUrl')) {
					<span
						class="cluster-icon"
						color="primary"
						(click)="openScreenshootLink(utils.suppressType(item))"
						matTooltip="{{ 'CLIPS.SCREENSHOT' | translate }}"
						matTooltipPosition="below">
						<mat-icon>photo</mat-icon>
					</span>
					} @if (utils.getParameterByName(item, 'fileUrl') && isImageUrl(utils.suppressType(item).fileUrl)) {
					<span
						class="cluster-icon"
						color="primary"
						(click)="utils.openLinkInNewTab(utils.suppressType(item).fileUrl.startsWith('http') ? utils.suppressType(item).fileUrl : externalAssetsRoot + utils.suppressType(item).fileUrl)"
						matTooltip="{{ 'CLIPS.SCREENSHOT' | translate }}"
						matTooltipPosition="below">
						<mat-icon>photo</mat-icon>
					</span>
					} @if (dataAdministrationType === 'CLIPPING' && utils.getParameterByName(item, 'source')) {
					<span
						class="cluster-icon"
						color="primary"
						(click)="openCluster(utils.suppressType(item))"
						matTooltip="{{ utils.getParameterByName(item, 'source') }}"
						matTooltipPosition="below">
						{{ getSourceIcon(utils.suppressType(item)) }}
					</span>
					} @if (utils.getParameterByName(item, 'transcribed')) {
					<span class="cluster-icon" color="primary" matTooltip="{{ 'CLIPS.TRANSCRIBED' | translate }}" matTooltipPosition="below">T</span>
					}
				</div>

				<!-- <span class="ms-auto insert-date">{{ utils.formatDate(item.insertDate, true) }}</span> -->
			</div>

			<div class="d-flex">
				<p class="flex-fill">{{ getDisplayFieldByDataType('brief', item) }}</p>

				@if (dataAdministrationType === 'CONTRACT_NOTICES' || dataAdministrationType === 'CONTRACT_ANNOUNCEMENTS') {
				<div class="flex-fill subtitle d-flex align-items-start justify-content-end flex-wrap mb-1">
					@if (getDisplayFieldByDataType('divisiblePurchase', item)) {
					<mat-icon>content_copy</mat-icon>
					<span>{{ 'CONTRACT_NOTICES.DIVISABLE_PURCHASE' | translate }}</span>
					} @if (getDisplayFieldByDataType('procurementType', item)) {
					<mat-icon class="ms-1">description</mat-icon>
					<span>{{ 'CONTRACT_NOTICES.CONTRACT_TYPES.' + getDisplayFieldByDataType('procurementType', item) | translate }}</span>
					}
					<img class="ms-3" width="19px" [src]="externalAssets + '/flags/' + getDisplayFieldByDataType('country', item) + '.svg'" alt="" />
					<span class="type ms-3">{{ getDisplayFieldByDataType('type', item) }}</span>
				</div>
				}

				@if (dataAdministrationType === 'TRANSCRIPTIONS') {
					<div class="cluster-icon-flag-container">
						<span
							class="cluster-icon"
							color="primary"
							(click)="openMediumLink(item)"
							[matTooltip]="(isPendingTranscription(item) ? 'TRANSCRIPTIONS.PENDING_TRANSCRIPTION' : ('TRANSCRIPTIONS.TYPES.' + utils.suppressType(item).type)) | translate"
							matTooltipPosition="below">

							@if (isPendingTranscription(item)) {
								<mat-icon>hourglass_top</mat-icon>
							} @else if (utils.suppressType(item).type === 'YOUTUBE') {
								<mat-icon>play_circle</mat-icon>
							} @else if (utils.suppressType(item).type === 'FILE') {
								<mat-icon>description</mat-icon>
							} @else if (utils.suppressType(item).type === 'URL') {
								<mat-icon>link</mat-icon>
							} @else if (utils.suppressType(item).type === 'RECORDING') {
								<mat-icon>mic</mat-icon>
							}
						</span>
						<img width="19px" [src]="externalAssets + '/flags/' + getDisplayFieldByDataType('lang', item) + '.svg'" alt="" />
					</div>
				}
			</div>
		</mat-card-content>

		@if (utils.getParameterByName(item, 'relatedCount') && hasRelatedClips(item)) {
		<mat-card-footer>
			<!-- Related news list -->
			<mat-accordion hideToggle="true" displayMode="flat">
				<mat-expansion-panel hideToggle [expanded]="item.expanded">
					@for (relatedClip of getItemRelatedClips(item); track $index) {
					<div class="related-news-header mat-elevation-z2 w-100 d-flex align-items-center ps-3 mb-1">
						<mat-checkbox
							color="primary"
							[(ngModel)]="relatedClip.checked"
							matTooltip="{{ utils.getParameterByLanguageScript(relatedClip, 'title', true) }}"
							matTooltipPosition="left"
							(change)="checkItem($event.checked, relatedClip)">
							<span class="info-text">{{ utils.formatDate(relatedClip.publicationDate) }}</span> |
							<span class="accent-text">{{ utils.getParameterByLanguageScript(relatedClip, 'title', true) }}</span></mat-checkbox
						>

						<!-- <div
							class="tags-placeholder ms-1 d-flex gap-2 flex-row flex-wrap flex-fill p-2"
							[id]="'tag-dropzone-list-' + relatedClip.id"
							cdkDropList
							(cdkDropListDropped)="tagsDropAssign.drop($event)">
							@for (tag of relatedClip.tags; track $index) {
							<div [style.background-color]="utils.getParameterByName(tag, 'colorCode')" class="tag-item d-flex align-items-center list-item">
								<span (click)="removeTag(relatedClip, tag)">
									{{ utils.getParameterByName(tag, 'value') }}
								</span>
							</div>
							}
						</div> -->
						<div class="tags-placeholder ms-1 d-flex gap-2 flex-row flex-wrap flex-fill p-0">
							@for (tag of relatedClip.tags; track $index) {
							<div [style.background-color]="utils.getParameterByName(tag, 'colorCode')" class="tag-item d-flex align-items-center list-item">
								<span>
									{{ utils.getParameterByName(tag, 'value') }}
								</span>
							</div>
							}
						</div>

						@if (utils.getParameterByName(item, 'clientId')) {
						<div class="admin-sentiment-panel related-row d-flex align-items-center ms-auto">
							<div class="metric-cell">
								<label class="metric-label">{{ 'CLIPS.REACH' | translate }}</label>
								@if (isEditingMetric(relatedClip, 'visibility')) {
								<input
									type="number"
									class="metric-input"
									min="0"
									max="100"
									[attr.data-edit-key]="relatedClip.id + ':visibility'"
									[value]="relatedClip.visibilityIndex ?? ''"
									(blur)="updateVisibilityIndex(relatedClip, $any($event.target).value); exitEditMetric(relatedClip, 'visibility')"
									(keydown.enter)="$any($event.target).blur()"
									(keydown.escape)="exitEditMetric(relatedClip, 'visibility')" />
								} @else {
								<span
									class="metric-display"
									(click)="enterEditMetric(relatedClip, 'visibility')"
									matTooltip="{{ 'CLIPS.REACH' | translate }}"
									matTooltipPosition="below">
									{{ relatedClip.visibilityIndex ?? '/' }}
								</span>
								}
							</div>
							<div class="metric-cell">
								<label class="metric-label">{{ 'CLIPS.INFLUENCE' | translate }}</label>
								@if (isEditingMetric(relatedClip, 'sentiment')) {
								<input
									type="number"
									class="metric-input"
									min="-100"
									max="100"
									[attr.data-edit-key]="relatedClip.id + ':sentiment'"
									[value]="relatedClip.sentiment?.sentimentScore ?? ''"
									(blur)="setSentimentScore(relatedClip, $any($event.target).value); exitEditMetric(relatedClip, 'sentiment')"
									(keydown.enter)="$any($event.target).blur()"
									(keydown.escape)="exitEditMetric(relatedClip, 'sentiment')" />
								} @else {
								<span
									class="metric-display"
									(click)="enterEditMetric(relatedClip, 'sentiment')"
									matTooltip="{{ 'CLIPS.INFLUENCE' | translate }}"
									matTooltipPosition="below">
									{{ relatedClip.sentiment?.sentimentScore ?? '/' }}
								</span>
								}
							</div>
							<div class="sentiment-group d-flex align-items-center ms-1">
								<button
									class="sentiment-btn"
									[ngClass]="getSentimentRating('POSITIVE', relatedClip, 'CLASS')"
									matTooltip="{{ 'CLIPS.SENTIMENT_RATING_TYPE.POSITIVE' | translate }}"
									matTooltipPosition="below"
									aria-label="Sentiment rating"
									(click)="createUpdateSentimentRating('POSITIVE', relatedClip)">
									<mat-icon>thumb_up_off_alt</mat-icon>
								</button>
								<button
									class="sentiment-btn"
									[ngClass]="getSentimentRating('NEUTRAL', relatedClip, 'CLASS')"
									matTooltip="{{ 'CLIPS.SENTIMENT_RATING_TYPE.NEUTRAL' | translate }}"
									matTooltipPosition="below"
									aria-label="Sentiment rating"
									(click)="createUpdateSentimentRating('NEUTRAL', relatedClip)">
									<mat-icon>remove</mat-icon>
								</button>
								<button
									class="sentiment-btn"
									[ngClass]="getSentimentRating('NEGATIVE', relatedClip, 'CLASS')"
									matTooltip="{{ 'CLIPS.SENTIMENT_RATING_TYPE.NEGATIVE' | translate }}"
									matTooltipPosition="below"
									aria-label="Sentiment rating"
									(click)="createUpdateSentimentRating('NEGATIVE', relatedClip)">
									<mat-icon>thumb_down_off_alt</mat-icon>
								</button>
							</div>
							@if (relatedClip.sentiment?.id) {
							<div
								class="taxonomy-trigger d-flex align-items-center ms-1"
								(click)="openTaxonomyDialog(relatedClip)"
								matTooltip="{{ 'CLIPS.TAXONOMY.EDIT_TITLE' | translate }}"
								matTooltipPosition="below">
								@if (hasTaxonomyValues(relatedClip)) {
								@if (relatedClip.sentiment?.sourceType) {
								<span class="taxonomy-chip source">{{ translateSourceTypeLabel(relatedClip.sentiment?.sourceType) }}</span>
								} @for (topic of relatedClip.sentiment?.industryTopics; track topic) {
								<span class="taxonomy-chip industry">{{ translateTopicLabel(topic) }}</span>
								} @for (topic of relatedClip.sentiment?.corporateTopics; track topic) {
								<span class="taxonomy-chip corporate">{{ translateTopicLabel(topic) }}</span>
								} } @else {
								<span class="taxonomy-chip placeholder">—</span>
								}
							</div>
							}
						</div>
						}

						<div class="medium-placeholder mat-elevation-z2 px-2 me-2 align-items-center cursor-pointer"
							[ngClass]="checkDuplicateMediumInRelated(item, relatedClip)"
							[class.ms-auto]="!utils.getParameterByName(item, 'clientId')"
							[class.ms-2]="utils.getParameterByName(item, 'clientId')">
							<span (click)="openMediumLink(relatedClip)">{{ utils.getParameterByLanguageScript(relatedClip.medium, 'name') }}</span>
							@if (airingTimesLabel(relatedClip); as airingLabel) {
							<span class="airing-times"> · {{ airingLabel }}</span>
							}
						</div>

						<div class="d-flex align-items-center flex-wrap buttons-bar">
							<button
								mat-stroked-button
								color="primary"
								matTooltip="{{ 'CLIPS.SET_AS_MAIN' | translate }}"
								matTooltipPosition="below"
								aria-label="Set as main button"
								(click)="itemAction('SET_AS_MAIN', relatedClip)">
								<mat-icon class="ms-1">arrow_upward</mat-icon>
							</button>

							<button
								mat-stroked-button
								color="primary"
								class="mx-1"
								matTooltip="{{ 'CLIPS.REPORT' | translate }}"
								matTooltipPosition="below"
								aria-label="Open report button"
								(click)="itemAction('OPEN_REPORT', relatedClip, 'SINGLE')">
								<mat-icon class="ms-1">picture_as_pdf</mat-icon>
							</button>

							<button
								mat-stroked-button
								color="primary"
								class="edit-button"
								matTooltip="{{ 'BUTTON.EDIT' | translate }}"
								matTooltipPosition="below"
								aria-label="Edit button"
								(click)="itemAction('EDIT_LIST_ITEM', relatedClip)">
								<mat-icon class="ms-1">edit</mat-icon>
							</button>
						</div>
					</div>
					<mat-divider></mat-divider>
					}
				</mat-expansion-panel>
			</mat-accordion>
			<!-- (END)Related news list -->
		</mat-card-footer>
		}
	</mat-card>

	}
</div>
